import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

export const defaultState = {
	currentUser: null,
	isAuthenticated: false,
	isPageAuthSuspended: false,
};

const SESSION_SET_AUTHENTICATED = (state, action) => {
	const { authenticated, currentUser, suspendPageAuth } = action;

	const nextState = { ...state, isAuthenticated: authenticated, currentUser };
	if (suspendPageAuth === true || suspendPageAuth === false) {
		nextState.isPageAuthSuspended = suspendPageAuth;
	}

	return nextState;
};

const SESSION_UPDATE_USER = (state, action) => {
	const { user } = action;
	return { ...state, currentUser: user };
};

const SESSION_UPDATE_USER_PRACTICE_AREAS = (state, action) => {
	const { practiceAreas } = action;
	return {
		...state,
		currentUser: {
			...state.currentUser,
			practice_areas: practiceAreas,
		},
	};
};

const SESSION_SET_PAGE_AUTH_SUSPENDED = (state, action) => {
	const { suspendPageAuth } = action;

	if (suspendPageAuth === true || suspendPageAuth === false) {
		return { ...state, isPageAuthSuspended: suspendPageAuth };
	}

	return state;
};

const SESSION_UPDATE_USER_TOKEN = (state, action) => {
	const { token } = action;
	return {
		...state,
		currentUser: {
			...state.currentUser,
			token: token,
		},
	};
};

const handlers = {};
handlers[actionTypes.SESSION_SET_AUTHENTICATED] = SESSION_SET_AUTHENTICATED;
handlers[actionTypes.SESSION_UPDATE_USER] = SESSION_UPDATE_USER;
handlers[actionTypes.SESSION_UPDATE_USER_PRACTICE_AREAS] = SESSION_UPDATE_USER_PRACTICE_AREAS;
handlers[actionTypes.SESSION_SET_PAGE_AUTH_SUSPENDED] = SESSION_SET_PAGE_AUTH_SUSPENDED;
handlers[actionTypes.SESSION_UPDATE_USER_TOKEN] = SESSION_UPDATE_USER_TOKEN;
export default createReducer(defaultState, handlers);
